// tslint:disable:max-line-length

import React from 'react';

export const EditorRemoveLink = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M8.4,10.3l-3.6,3.6c-0.5,0.5-1.4,0.5-1.9,0l-0.7-0.7c-0.5-0.5-0.5-1.4,0-1.9l3.6-3.6L4.5,6.4L0.9,10c-0.6,0.6-1,1.4-0.9,2.3 c0,0.8,0.4,1.5,0.9,2.1l0.7,0.7C2.2,15.7,3,16,3.9,16c0,0,0,0,0.1,0c0.8,0,1.5-0.4,2.1-0.9l3.5-3.5l0.1-0.1L8.4,10.3z" />
      <path d="M15.1,1.6l-0.7-0.7C13.8,0.3,12.9,0,12.1,0c-0.8,0-1.5,0.4-2.1,0.9L6.4,4.5l1.2,1.2l3.6-3.6c0.5-0.5,1.4-0.5,1.9,0l0.7,0.7 c0.5,0.5,0.5,1.4,0,1.9l-3.6,3.6l1.3,1.3L15.1,6c0.6-0.6,1-1.4,0.9-2.3C16,2.9,15.6,2.2,15.1,1.6z" />
      <rect x="1.8" y="0.5" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -0.9364 2.2607)" width="1" height="3.5" />
      <rect x="4.4" y="1" width="1" height="2" />
      <rect x="1.5" y="3.9" transform="matrix(6.123234e-17 -1 1 6.123234e-17 -2.9232 6.9232)" width="1" height="2" />
      <rect
        x="13.1"
        y="11.8"
        transform="matrix(-0.7071 0.7071 -0.7071 -0.7071 32.7467 13.5642)"
        width="1"
        height="3.5"
      />
      <rect x="10.6" y="13" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 22.1537 28)" width="1" height="2" />
      <rect
        x="13.5"
        y="10.1"
        transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 25.0768 -2.9232)"
        width="1"
        height="2"
      />
    </svg>
  );
};
